<template>
  <!-- CMS が存在する Destination / Theme タグ。特集 (Itinerary) と同じ行表示で、遷移先は特集ページ -->
  <FeatureRow :category-label="categoryLabel" :on-click="props.onClick" :thumbnail-url="thumbnailUrl" :title="featured.titleEn" :to="path" />
</template>

<script setup lang="ts">
import { generateDetailPageLink, getBackgroundImageUrl, type MinimumFeaturedViewModel } from '@/wabunka-src/common/features/Featured/models/minimunFeatured/minimumFeatured';
import FeatureRow from '@/wabunka-src/features/Search/components/model/FeatureRow.vue';

interface Props {
  featured: MinimumFeaturedViewModel;
  onClick?: () => void;
}

const props = defineProps<Props>();

const thumbnailUrl = computed(() => getBackgroundImageUrl(props.featured));
const path = computed(() => generateDetailPageLink(props.featured));
// FeatureItem の getFeatureCategoryDisplayLabel と表記を揃える（destination → Featured Destination、theme/category → Explore by Theme）
const categoryLabel = computed(() => (props.featured.type === 'destination' ? 'Featured Destination' : 'Explore by Theme'));
</script>
